export const server_url = "https://gudhub.com/GudHub_Test";
//export const server_url = "https://gudhub.com/GudHub_Temp";
//export const server_url = "https://integration.gudhub.com/GudHub_Test";
//export const server_url = "http://localhost:9000";
export const wss_url = "wss://gudhub.com/GudHub/ws/app/";
export const node_server_url = "https://gudhub.com/api/services/prod"
export const async_modules_path = 'build/latest/async_modules_node/';
export const automation_modules_path = 'build/latest/automation_modules/'
export const file_server_url = 'https://gudhub.com'

export const cache_chunk_requests = true;
export const cache_app_requests = true;

// FOR TESTS
export const port = 9000;
